export default "__VITE_ASSET__BPO3fsPv__"